<template>
  <span class="ps-relative ps-z-0 ps-inline-flex ps-shadow-sm ps-rounded-md">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'ButtonGroupBasic'
}
</script>
